import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-26c2c93c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "assign-modal" }
const _hoisted_2 = { class: "custom-dropdown__inner" }
const _hoisted_3 = { class: "custom-dropdown__menu" }
const _hoisted_4 = { class: "custom-dropdown__search" }
const _hoisted_5 = { class: "custom-dropdown__menu-inner" }
const _hoisted_6 = { class: "custom-dropdown__specialisms" }
const _hoisted_7 = { class: "custom-dropdown__specialisms-item" }
const _hoisted_8 = ["src"]
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "custom-dropdown__label" }, [
  /*#__PURE__*/_createElementVNode("p", null, "Select Certificate")
], -1))
const _hoisted_10 = { class: "custom-dropdown__inner" }
const _hoisted_11 = { class: "custom-dropdown__menu" }
const _hoisted_12 = { class: "custom-dropdown__search" }
const _hoisted_13 = { class: "custom-dropdown__menu-inner" }
const _hoisted_14 = { class: "assign-modal-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_checkbox = _resolveComponent("v-checkbox")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_GeneralDialog = _resolveComponent("GeneralDialog")!

  return (_openBlock(), _createBlock(_component_GeneralDialog, {
    headerTitle: "Select the Certificate and Specialisms to carry forward.",
    onOnClose: $setup.onCloseModal
  }, {
    body: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", {
          class: _normalizeClass(["custom-dropdown", { 'is-open': $setup.isOpenCategory }])
        }, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("button", {
              type: "button",
              class: "custom-dropdown__trigger",
              onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.isOpenCategory = !$setup.isOpenCategory))
            }, [
              _createElementVNode("p", null, _toDisplayString($setup.selectedSubCategory.length
                    ? $setup.selectedSubCategoryName
                    : "Please select a category"), 1),
              _createVNode(_component_v_icon, {
                icon: "mdi-chevron-down",
                color: "#0C0F4A"
              })
            ]),
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createVNode(_component_v_text_field, {
                  variant: "outlined",
                  placeholder: "Search Specialisms",
                  "prepend-inner-icon": "mdi-magnify",
                  modelValue: $setup.searchCategory,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.searchCategory) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.filterCategory, (specialism, index) => {
                    return (_openBlock(), _createBlock(_component_v_checkbox, {
                      color: "#4F55F0",
                      key: index,
                      modelValue: $setup.selectedSubCategory,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.selectedSubCategory) = $event)),
                      value: specialism.subCategory.id,
                      onClick: ($event: any) => ($setup.onClickMainCategory(specialism.subCategory.id))
                    }, {
                      label: _withCtx(() => [
                        _createElementVNode("div", _hoisted_7, [
                          (specialism.subCategory.category.iconName)
                            ? (_openBlock(), _createBlock(_component_v_icon, {
                                key: 0,
                                class: "custom-dropdown__specialisms-icon"
                              }, {
                                default: _withCtx(() => [
                                  (specialism.subCategory.category.iconName)
                                    ? (_openBlock(), _createElementBlock("img", {
                                        key: 0,
                                        style: {"width":"14px"},
                                        src: 
                              require('@/assets/category-icons/' +
                                specialism.subCategory.category.iconName +
                                '.svg')
                            ,
                                        alt: "icon"
                                      }, null, 8, _hoisted_8))
                                    : _createCommentVNode("", true)
                                ]),
                                _: 2
                              }, 1024))
                            : _createCommentVNode("", true),
                          _createElementVNode("h2", null, _toDisplayString(specialism?.subCategory?.label), 1)
                        ])
                      ]),
                      _: 2
                    }, 1032, ["modelValue", "value", "onClick"]))
                  }), 128))
                ])
              ])
            ])
          ])
        ], 2),
        _createElementVNode("div", {
          class: _normalizeClass(["custom-dropdown custom-dropdown-certificate", { 'is-open': $setup.isOpenCertificates }])
        }, [
          _hoisted_9,
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("button", {
              type: "button",
              class: "custom-dropdown__trigger",
              onClick: _cache[3] || (_cache[3] = ($event: any) => ($setup.isOpenCertificates = !$setup.isOpenCertificates))
            }, [
              _createElementVNode("p", null, _toDisplayString($setup.selectedCertificate.length
                    ? $setup.selectedCertificatesName
                    : "Please Select Certificate"), 1),
              _createVNode(_component_v_icon, {
                icon: "mdi-chevron-down",
                color: "#0C0F4A"
              })
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _createVNode(_component_v_text_field, {
                  variant: "outlined",
                  placeholder: "Search Specialisms",
                  "prepend-inner-icon": "mdi-magnify",
                  modelValue: $setup.searchCertificate,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($setup.searchCertificate) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_13, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.filterCertificate, (certificate, index) => {
                  return (_openBlock(), _createBlock(_component_v_checkbox, {
                    color: "#4B4BFF",
                    label: certificate.certificate.name,
                    key: index,
                    modelValue: $setup.selectedCertificate,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (($setup.selectedCertificate) = $event)),
                    value: certificate.certificate.id
                  }, null, 8, ["label", "modelValue", "value"]))
                }), 128))
              ])
            ])
          ])
        ], 2)
      ])
    ]),
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_14, [
        _createVNode(_component_v_btn, {
          class: "button button-purple-border",
          onClick: $setup.onCloseModal
        }, {
          default: _withCtx(() => [
            _createTextVNode("Cancel")
          ]),
          _: 1
        }, 8, ["onClick"]),
        _createVNode(_component_v_btn, {
          class: "button button-orange",
          onClick: $setup.onContinueButtonClick
        }, {
          default: _withCtx(() => [
            _createTextVNode("Continue")
          ]),
          _: 1
        }, 8, ["onClick"])
      ])
    ]),
    _: 1
  }, 8, ["onOnClose"]))
}